import { Outlet } from 'react-router-dom';

import TabsNavigation from 'components/TabsNavigation/TabsNavigation';
import Button from 'components/Button/Button';

import colors from 'theme/Colors.module.scss';
import './UsersContainer.scss';

import { Box } from '@chakra-ui/react';

export default function UsersContainer({ searchLegend }) {
  const usersIndexPath = `/users`;
  const invitationsIndexPath = `/users/invited`;

  return (
    <Box>
      {/* Shared header */}
      <Box className="users-header">
        <Box className="users-header__left">
          <Button
            type="button"
            icon="add"
            text="New User"
            textColor={colors.slate}
            btnStyle="transparent"
            url="/users/new"
          />
          <Button
            type="button"
            icon="paper-plane"
            text="Invite User"
            textColor={colors.slate}
            btnStyle="transparent"
            url="/users/invite"
          />
        </Box>

        <Box className="users-header__nav">
          <TabsNavigation
            tabs={[
              { key: 'users', label: 'Users', exact: true, to: usersIndexPath },
              {
                key: 'invitations',
                label: 'Invited',
                to: invitationsIndexPath,
              },
            ]}
          />
        </Box>

        <Box className="users-header__right">{searchLegend}</Box>
      </Box>

      {/* Nested route content */}
      <Outlet />
    </Box>
  );
}
